import { useTranslation } from 'react-i18next';

import { TabsContent } from '@/components/ui/tabs';
import { BrainDetailsSection } from '@/modules/tryIt/components/LogSections/DetailsSection/BrainDetailsSection/BrainDetailsSection';
import type { AmendPayload } from '@/shared/types/tryIt';

interface DetailsTabProps {
  hasTurnSelected: boolean;
  detailsContent: { session_id?: string; brain_parent_id?: string };
  simulationContext: NonNullable<AmendPayload['simulation']>;
}

export const DetailsTab = ({
  hasTurnSelected,
  detailsContent,
  simulationContext,
}: DetailsTabProps) => {
  const { t } = useTranslation();

  return (
    <TabsContent value="details" className="flex-1 overflow-y-auto p-4">
      {hasTurnSelected ? (
        <BrainDetailsSection content={detailsContent} simulation={simulationContext} />
      ) : (
        <p className="text-sm text-muted-foreground">
          {t('simulations.select_turn_to_see_details')}
        </p>
      )}
    </TabsContent>
  );
};
